$(document).ready(
    function () {
        const p = $("body").attr("p");
        if (p === 'shopping_cart') {
            $(document).on("click", ".cart-remove-order-btn", function (e) {
                e.preventDefault();
                let orderId = $(this).data("order-id");
                let removeOrderFromShoppingCartAjaxLock = false;
                let parentOrderElement = $(this).closest(".shopping-cart-order");
                let isComboEvent = $(this).hasClass('cart-remove-combo-event');

                let ajaxPostData = {
                    order_id: orderId
                }

                let orderCombosText = '';
                if (isComboEvent) {
                    ajaxPostData.order_combo_id = $(this).data("order-combo-id");
                    orderCombosText = $('.order-combos-text', parentOrderElement).text();
                }

                if (!removeOrderFromShoppingCartAjaxLock && !isNaN(orderId) && (!isComboEvent || (isComboEvent && confirm($(this).data('combo-confirm-message') + ' ' + orderCombosText)))) {
                    removeOrderFromShoppingCartAjaxLock = true;
                    $.ajax({
                        type: 'POST',
                        url: "/ajax/shopping_cart/cancel_reservation",
                        data: ajaxPostData
                    })
                        .done(function (data) {
                            if (data.order_multi_sum !== undefined) {
                                $('#shopping-cart-btn-sum').text(data.order_multi_sum);
                                parentOrderElement.fadeOut(1000, function () {
                                    parentOrderElement.remove();

                                    if (isComboEvent) {
                                        $('.cart-remove-combo-event[data-order-combo-id="' + ajaxPostData.order_combo_id + '"]').each(function () {
                                            $(this).closest(".shopping-cart-order").remove();
                                        });
                                    }

                                    if ($('.shopping-cart-order').length === 0) {
                                        $('#empty-shopping-cart').removeClass('d-none');
                                        $('#order-multi-form-wrapper').remove();
                                        $('#order-multi-count-down').remove();

                                        $('#menuLinks').removeClass('shopping-cart-link-visible');
                                        $('#menuLinks .navbar-nav').addClass('ml-auto');
                                        $('#shopping-cart-btn').remove();
                                    }
                                });
                                popupAlert();
                            }
                        })
                        .fail(function (data) {
                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }
                            if (data.responseJSON.error_message !== undefined && data.responseJSON.error_message !== null) {
                                popupAlert(3000, 'danger', data.responseJSON.error_message);
                            }
                        })
                        .always(function () {
                            removeOrderFromShoppingCartAjaxLock = false;
                        });
                }
            });

            let orderMultiFromAjaxLock = false;
            $(document).on("submit", "#order_multi_form", function (e) {
                e.preventDefault();

                if (!orderMultiFromAjaxLock) {
                    $("#order_multi_form #order-multi-submit-btn").prop("disabled", true);
                    orderMultiFromAjaxLock = true;

                    let formData = new FormData(
                        document.getElementById("order_multi_form")
                    );

                    if (
                        $("#clipping_card_code_validated").length !== 0 &&
                        $("#clipping_card_code_validated").text() != ""
                    ) {
                        formData.append(
                            "clipping_card_code",
                            $("#clipping_card_code_validated").text()
                        );
                    } else {
                        if (formData.has("clipping_card_code")) {
                            formData.delete("clipping_card_code");
                        }
                    }

                    if (
                        $("#gift_card_code_validated").length !== 0 &&
                        $("#gift_card_code_validated").text() != ""
                    ) {
                        formData.append(
                            "gift_card_code",
                            $("#gift_card_code_validated").text()
                        );
                    } else {
                        if (formData.has("gift_card_code")) {
                            formData.delete("gift_card_code");
                        }
                    }

                    $.ajax({
                        type: "POST",
                        url: "/ajax/shopping_cart/payment",
                        data: formData,
                        async: true,
                        cache: false,
                        processData: false,
                        contentType: false,
                    })
                        .done(function (data) {
                            let enableSubmitButton = true;
                            if (
                                data.payment_redirect_url !== undefined &&
                                data.payment_redirect_url !== null
                            ) {
                                if (data.redirect_to_pos !== undefined) {
                                    $("#order-multi-form-wrapper").hide();
                                }
                                document.location.href = data.payment_redirect_url;
                                enableSubmitButton = false;
                            }

                            if (
                                data.confirmation_code !== undefined &&
                                data.confirmation_code !== null
                            ) {
                                document.location.href =
                                    "/order/confirmation/" + data.confirmation_code;
                                enableSubmitButton = false;
                            }

                            if (enableSubmitButton) {
                                $("#order_multi_form #order-multi-submit-btn").prop(
                                    "disabled",
                                    false
                                );
                            }
                        })
                        .fail(function (data) {
                            if (
                                data.responseJSON !== undefined &&
                                data.responseJSON.error_message !== undefined &&
                                data.responseJSON.error_message !== null
                            ) {
                                prependAlert(
                                    "#div_order_buttons",
                                    data.responseJSON.error_message,
                                    "danger",
                                    null,
                                    "#order_multi_form"
                                );
                            }

                            orderMultiFromAjaxLock = false;
                            $("#order_multi_form #order-multi-submit-btn").prop("disabled", false);
                        })
                        .always(function () {
                            orderMultiFromAjaxLock = false;
                        });
                }
            });

            $(document).on('click', '#cancel-reservation-multi-btn', function (e) {
                e.preventDefault();
                let cancelReservationMultiAjaxLock = false;
                if (!cancelReservationMultiAjaxLock) {
                    cancelReservationMultiAjaxLock = true;
                    $.ajax({
                        type: 'GET',
                        url: "/ajax/shopping_cart/cancel_reservation_timeout"
                    })
                        .done(function () {
                            $('#empty-shopping-cart').removeClass('d-none');
                            $('#shopping-cart-wrapper .alert').remove();
                            $('.shopping-cart-order').each(function () {
                                $(this).remove();
                            });
                            $('#order-multi-form-wrapper').remove();
                            $('#order-multi-count-down').remove();

                            $('#menuLinks').removeClass('shopping-cart-link-visible');
                            $('#menuLinks .navbar-nav').addClass('ml-auto');
                            $('#shopping-cart-btn').remove();
                            history.pushState({}, null, '/cart');
                        })
                        .always(function () {
                            cancelReservationMultiAjaxLock = false;
                        })
                }
            });
        }
    }
);

